import { TFreightie, TUser } from '../Actors'
import { IActivityTitle } from '../messages/MessageSectionType'
import { FORTO_AVATAR, INITIALS_AVATAR, TAvatarType, THUMBNAIL_AVATAR } from './AvatarType'

export function getAvatarType(actor: TFreightie | TUser): TAvatarType {
  if (!actor) {
    return FORTO_AVATAR
  }
  if ((actor as TFreightie).thumbnailUrl) {
    return THUMBNAIL_AVATAR
  }
  return INITIALS_AVATAR
}

/**
 * Note: There are a large number of usages of <Avatar /> that do not use this function, so it cannot be
 * used as a single point for censoring initials.
 *
 * @see https://forto.atlassian.net/browse/PA-3150
 */
export function getAvatar(actor: TFreightie | TUser): string {
  if (!actor) {
    return 'FH'
  }
  if ((actor as TFreightie).thumbnailUrl) {
    return (actor as TFreightie).thumbnailUrl
  }
  return actor.initials
}

export function getTitleFromActor(actor: TFreightie | TUser): IActivityTitle {
  if (!actor) {
    return { text: 'activity-feed_deleted_user', translate: true }
  }
  return { text: actor.name }
}

const isShipUserID = (id: string | undefined): boolean => id?.startsWith('U-') ?? false

export const getUserType = (userId?: string): 'customer' | 'fortie' | undefined => {
  if (userId) return isShipUserID(userId) ? 'customer' : 'fortie'
}
